import { useQuery, type UseQueryResult } from '@tanstack/react-query'
import { clientService } from '@/services/ClientService'
import { clientKeys } from '@/hooks/queryKeys'
import type { ClientDetailDto } from '@lib/dto/client.dto'

/** Load one client with its contacts and sites. */
export function useClient(id: string): UseQueryResult<ClientDetailDto> {
  return useQuery({
    queryKey: clientKeys.detail(id),
    queryFn: () => clientService.get(id),
    enabled: id !== '',
    staleTime: 15_000,
  })
}
